export function HowToUseIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={18}
            height={20}
            viewBox="0 0 512 512"
        >
            <g>
                <path
                    d="M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm0 384c-88.4 0-160-71.6-160-160S167.6 96 256 96s160 71.6 160 160-71.6 160-160 160z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
                <path
                    d="M256 144c-44.2 0-80 35.8-80 80h48c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3-8.2 25.2-20.6 30l-11.4 4.6c-29.1 11.6-48 39.8-48 71.1V344h48v-14.3c0-11.8 7.1-22.4 18-26.7l11.4-4.6c30.7-12.3 50.6-41.8 50.6-74.4 0-44.2-35.8-80-80-80z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
                <circle cx="256" cy="400" r="24" fill="#000000" />
            </g>
        </svg>
    );
}